import React from "react";
import { connect } from "react-redux";
import { compose, showAlert } from "utils/WebUtils";
import clsx from "classnames";
import { Link } from "react-router-dom";
import { hasRole } from "utils/auth";
import { Auth } from "aws-amplify";
import { AccountingUtils } from "revlock-accounting";
import UserActions from "redux/actions/user.actions";
import { getMenuItems } from "../../../config";
import { endImpersonation as removeImpersonation, getOrgConfigurations as getSiteConfig } from "rest/API";
import { withCookies } from "react-cookie";
import config from "cfg/config";

import {
    triggerAcTour,
    currentOrganization,
    currentUser,
    getClientTablesConfig,
    getOrgConfigurations,
} from "redux/selectors";
import {
    Button
} from "@material-ui/core";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { SecurityUtils } from "revlock-webutils";
import * as WebUtils from "utils/WebUtils";

import swal from "sweetalert";

import { Alert } from "@material-ui/lab";
import { contactSales, addAuditEvent } from "rest/API";

import { withRouter } from "react-router-dom";
import {
    addTestTransactions,
    deleteEnvironment
} from "rest/API";
import { invalidateAll } from "redux/actions";
import { setData2, resetOrg, setCookies } from "redux/actions";

import JobProgress from "components/JobProgress";

import { CBNavbar } from "@chargebee/cb-navbar";
import { set } from "lodash";


const styles = (theme) => ({
    mobilelogo: {
        display: "none"
    },
    mobileshowlogo: {
        display: "block",
        paddingLeft: "0",
        paddingRight: "0",
        minHeight: "35px",
        "& .MuiAvatar-root": {
            padding: "0",
            marginTop: "15px",
            marginLeft: "auto",
            marginRight: "auto"
        }
    },
    sideNavDockedOverride: {
        backgroundColor: theme.palette.background.dockedMenu,
        "& .MuiListItemText-root": {
            color: "#ffffff"
        },
        "& .MuiListItem-root": {
            "&:hover": {
                backgroundColor: `${theme.palette.background.primary[600]} !important`,
                minWidth: "35px"
            }
        },
        "& .MuiListItemIcon-root": {
            paddingRight: "0px",
            width: "35px"
        },
        "& .MuiButtonBase-root": {
            width: "35px",
            padding: "3px 0px"
        },
        "& .submenuwindow": {
            "& .MuiListItemIcon-root": {
                marginRight: "0px"
            },
            "& .MuiListItem-root": {
                paddingTop: "2px",
                paddingBottom: "2px",
                paddingLeft: "4px",
                background: "transparent",
                width: "100%",
                "& .MuiSvgIcon-root": {
                    fill: "#eaeaf4"
                },
                "&:hover": {
                    width: "100%"
                }
            },
            "& .MuiListItemText-root": {
                "& .MuiTypography-body1": {
                    fontWeight: "400"
                }
            }
        }
    },
    contentWrapper: {
        height: "100%"
    },
    content: {
        width: "100%",
        minWidth: "100%",
        height: "100%",
        minHeight: "100%",
        margin: "0",
        overflowY: "auto",
        "-ms-overflow-style": "none",
        "&::-webkit-scrollbar": {
            width: "0"
        }
    },

    list: {
        paddingTop: 0,
        paddingBottom: 0
    },
    listItemRoot: {
        // flexDirection: 'column',
        // alignItems: 'start',
        // display: 'flex',
        paddingBottom: 0,
        paddingTop: 0,
        color: "white"
    },
    listItem: {
        textTransform: "none",
        display: "flex",
        paddingTop: 0,
        paddingBottom: 0,
        width: "100%",
        minHeight: 96,
        alignItems: "center",
        boxSizing: "border-box",
        paddingLeft: 16,
        paddingRight: 16
    },
    listItemActive: {
        backgroundColor: theme.palette.background.url,
        fontSize: 14,
        fontWeight: 600,
        color: "#eaeaf4",
        "&hover": {
            backgroundColor: theme.palette.background.url,
            fontWeight: 600
        },
        "& .MuiSvgIcon-root": {
            fill: "black"
        },
        "& .MuiListItemText-root": {
            "& .MuiTypography-body1": {
                color: theme.palette.background.neutral[500]
            }
        }

        // '& svg': {
        //   color: 'black'
        // },
        // '& div': {
        //   color: 'black !important',
        //   fontWeight: 700,
        // },
        // '& p': {
        //   color: 'black !important',
        //   fontWeight: 700,
        // }
    },
    listItemButtonLabel: {
        flexDirection: "column"
    },
    dockedListItemText: {
        color: theme.palette.background.neutral[200],
        flex: "1 1 100%",
        textTransform: "none",
        fontSize: 14,
        lineHeight: 1.75,
        "&hover": {
            color: theme.palette.background.neutral[600],
            fontWeight: 600
        }
    },
    listItemText: {
        color: theme.palette.background.neutral[700],
        flex: "1 1 100%",
        textTransform: "none",
        fontSize: 14,
        lineHeight: 1.75,
        "&hover": {
            color: theme.palette.background.neutral[600],
            fontWeight: 600
        }
    },
    logo: {
        paddingRight: theme.spacing(1),
        width: theme.spacing(3),
        height: theme.spacing(3)
    },
    avatar: {
        width: theme.spacing(3),
        height: theme.spacing(3)
    },

    listIcon: {
        "& .MuiSvgIcon-root": {
            width: "18px",
            marginLeft: "0px"
        },
        height: "18px",
        color: theme.palette.background.neutral[600],
        marginLeft: "auto",
        marginRight: "auto",
        "&hover": {
            color: theme.palette.background.neutral[200]
        }
    },
    lockIcon: {
        height: "17px",
        color: theme.palette.background.neutral[600],
        marginTop: "5px"
    },
    getStartedListItemIconOverrides: {
        color: theme.palette.background.button.main
    },
    getStartedListItemTextOverrides: {
        color: theme.palette.background.button.main
    },
    listText: {
        fontSize: "15px"
    },
    item: {
        paddingTop: "3px",
        paddingBottom: "3px"
    },
    listItemIconOverrides: {
        color: theme.palette.background.neutral[600],
        minWidth: theme.spacing(3),
        height: theme.spacing(3),
        paddingRight: 12
    },
    listItemGuttersOverrides: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1)
    },
    listItemRootOverrides: {
        padding: "1px 8px",
        borderRadius: theme.spacing(0.5),
        marginLeft: "auto",
        marginRight: "auto",
        marginBottom: "2px",
        position: "relative",
        zIndex: "999"
    },
    minIconWidth: {
        minWidth: "32px"
    },
    subItem: {
        color: theme.palette.background.neutral[500],
        fontSize: "0.75rem",
        fontWeight: 400
    },
    divider: {
        width: "100%",
        marginBottom: theme.spacing(1)
    },
    root: {
        paddingTop: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1)
    },
    alert: {
        textWrap: "wrap"
    },
    alertHeading: {
        marginBottom: "6px",
        marginTop: 0
    },
    alertButton: {
        marginTop: "12px"
    }
});

const whatsNew = {
    label: "What's New?",
    linkTo: "https://chargebee.com/whats-new",
    target: "_blank",
    show: true,
};

// --- Site Switcher ---
const siteSwitcher = {
    id: "site-switcher",
    icon: "globe",
    description: "Switch between your sites",
    actions: [],
    searchPlaceholderText: "Search sites",
    onClickClosePopover: true,
    onSearch: async (query) => {
        // Return filtered items or undefined to show all
        if (!query) return;
        // Can return filtered items from API
        return siteSwitcher.items.filter((site) =>
            site.label.toLowerCase().includes(query.toLowerCase())
        );
    },
    noItemsFoundText: "No sites found",
    activeItemLabelText: "Currently viewing",
    itemListLabelText: "Other sites you have access to",
};

const exploreProductOptions = [];

// --- Products ---
const currentProduct = {
    name: "revRec",
    displayName: "RevRec"
};

class MenuSidenavCompact extends React.Component {
    constructor(props) {
        super(props);
    }

    handleOnClick = (index) => {
        this.setState({ activeIndex: index });
    };
    state = {
        anchor: null,
        open: null,
        openMenu: {},
        activeNavItemID: 'Home',
        collapsed: false,
        selectedBusinessEntity: (this.props.currentOrganization.businessEntities &&
            this.props.currentOrganization.businessEntities.length > 0 &&
            this.props.currentOrganization.businessEntities[0]) || {},
        selectedBusinessEntityId: undefined
    };

    componentDidUpdate(prevProps, prevState) {
        const prevEntities = prevProps.currentOrganization?.businessEntities;
        const entities = this.props.currentOrganization?.businessEntities;

        const entitiesChanged = prevEntities !== entities;
        const idChanged =
            prevState.selectedBusinessEntityId !== this.state.selectedBusinessEntityId;

        // If entities changed or a new explicit selection was made, re-sync.
        if (entitiesChanged || idChanged) {
            this.syncFromPropsAndCookie();
            return;
        }

        // If we still have no selection but entities exist, try to sync once.
        if (
            !this.state.selectedBusinessEntity &&
            Array.isArray(entities) &&
            entities.length > 0
        ) {
            this.syncFromPropsAndCookie();
        }
    }

    syncFromPropsAndCookie = () => {
        const org = this.props.currentOrganization;
        const entities = org?.businessEntities ?? [];
        if (!entities.length) return;

        const cookieBeId = WebUtils.get("cookies")?.cookies?.businessEntityId;

        const desiredId =
            this.state.selectedBusinessEntityId ??
            cookieBeId ??
            entities[0].Business_Entity_Id;

        // No-op if already selected
        if (
            this.state.selectedBusinessEntity?.Business_Entity_Id === desiredId
        ) {
            return;
        }

        const be =
            entities.find((e) => e.Business_Entity_Id === desiredId) ??
            entities[0];

        this.setState(
            {
                selectedBusinessEntity: be,
                selectedBusinessEntityId: undefined, // clear transient selector
            },
            () => {
                // persist cookie
                setCookies("businessEntityId", be.Business_Entity_Id, { path: "/" });

                // dispatch WITHOUT mutating props
                UserActions.setCurrentOrganization(
                    { ...org, be_id: be.Business_Entity_Id },
                    false
                );
            }
        );
    };

    handleClose = () => {
        this.setState({ anchor: null, open: null });
    };

    handleClick = (event, title) => {
        const id = "id-" + this.props.space + "-" + title;
        const newMenu = this.state.openMenu;
        newMenu[id] = !this.state.openMenu[id];
        this.setState({ openMenu: newMenu });
    };

    showGetStarted = () => {
        const { history } = this.props;

        history && history.push("/");

        setData2("showWelcomeTour", true);
    };

    showAcOnboardingTour = () => {
        setData2("currentJoyRide", "AcOnboardingTour");
        setData2("joyRideData", { run: true, stepIndex: 0 });
        this.setState({ openMenu: { "id-ac-Settings": true } });
    };

    signOut = (value = true) => {
        UserActions.signOut(value)
            .then(() => {
                this.changeState("signedOut");
            })
            .catch((err) => {
                logger.error(err);
            });
    }

    callExpert = async () => {
        const { currentOrganization } = this.props;
        const allPlans = SecurityUtils.allPlans();
        const upgradeTo = allPlans[currentOrganization.license.name].nextPlan;

        try {
            await contactSales(currentOrganization.id, "plan", upgradeTo);

            await swal({
                title: `Thank you!!`,
                icon: "success",
                text: `Our RevRec teammate will contact you shortly.`
            });
        } catch (err) {
            await swal({
                title: "Error",
                icon: "error",
                text: `Something didn't quite work ${err.errorMessage}`,
                error: true,
                timer: 2000,
                buttons: false
            });
        }
    };

    componentDidMount = () => {
        setTimeout(async () => {
            const {
                triggerAcTour,
                history,
                currentOrganization,
                isACSite
            } = this.props;
            if (isACSite && triggerAcTour) {
                this.showAcOnboardingTour();
            }

        }, 1000);
        this.syncFromPropsAndCookie()
    };

    canPerformAction = () => {
        const { isReadOnlyOrg } = this.props;
        if (isReadOnlyOrg) {
            swal({
                title: "Error",
                text: `You dont have permission to perform this operation`,
                icon: "error",
                dangerMode: true,
                buttons: "ok"
            });
            return false;
        }

        return true;
    };

    handleItemClick = (e, item) => {
        const { currentOrganization } = this.props;

        if (item.id === "Reports" || item.id == 'Closing Reports') {
            this.setState({
                collapsed: true
            });
        } else {
            this.setState({
                collapsed: false
            });
        }
        return <Link reloadDocument to={`/${currentOrganization.id}/${item.linkTo}`} />;
    }

    // Custom link renderer for React Router
    customLinkRenderer = (props) => {
        const { currentOrganization } = this.props;
        let linkTo = `/${currentOrganization.id}/${props.to}`
        if (props.to.startsWith('admin/')
            || props.to.startsWith('ac/')
            || props.to.includes('/ac/')
        ) {
            linkTo = `/${props.to}`
        }
        if (props.to.includes('switch')) {
            linkTo = `${(props.to).replace('switch', '')}`;
        }

        return <Link {...props} reloadDocument to={linkTo} />;
    };


    onDelete = async () => {
        const { currentOrganization, patchOrganization, history } = this.props;
        const org = currentOrganization
        const adminUser = hasRole("Admin");

        if (!this.canPerformAction()) {
            return;
        }

        if (!adminUser) {
            return;
        }

        let message = {
            title: "Are you sure?",
            text: "This will delete all the orders in your environment",
            icon: "warning",
            dangerMode: true,
            buttons: true
        };

        const isTestOrg = AccountingUtils.isTestId(org.id);

        if (!isTestOrg) {
            message = Object.assign(message, {
                title: `!! YOU ARE CONNECTED TO ${org.name} LIVE SITE !!`,
                text: "You are about to DELETE all the data in this site.",
                buttons: ["Cancel", `Yes! clear live site.`]
            });
        }

        const willDelete = await swal(message);

        if (willDelete) {
            try {
                await deleteEnvironment(org.id);
                let _org = Object.assign({}, org);
                _org.currentPeriod = "";
                patchOrganization && patchOrganization(_org);

                resetOrg();

                history.push("/");

                invalidateAll();
            } catch (e) {
                swal(
                    "Error",
                    e.errorMessage ||
                    e.text ||
                    "Error occured while clearing environment",
                    "error"
                );
            }
        }
    };

    onCopy = async () => {
        const { currentOrganization, patchOrganization, fetchNotifications } = this.props;
        const org = currentOrganization;
        if (!this.canPerformAction()) {
            return;
        }

        const agreeToCreate = await swal({
            title: "Are you sure?",
            text: "This will copy some test orders in your test environment",
            icon: "warning",
            dangerMode: true,
            buttons: true
        });

        if (agreeToCreate) {
            setTimeout(
                () => fetchNotifications && fetchNotifications(),
                2 * 1000
            );

            addTestTransactions(org.id)
                .then(() => {
                    fetchNotifications && fetchNotifications();
                    let _org = Object.assign({}, org);
                    _org.currentPeriod = "";
                    patchOrganization && patchOrganization(_org);
                })
                .catch((err) => {
                    if (err.errorMessage) {
                        swal(
                            "error",
                            `Something didn't quite work ${err.errorMessage}`,
                            "error"
                        );
                    }
                });
        }
    };

    contactSupport = () => {
        const { currentOrganization } = this.props;
        addAuditEvent(currentOrganization.id, {
            eventType: "contact_support_clicked",
            entityType: "contact_support",
            entityId: "Contact Support",
            message: `User clicked to send Contact Support email`
        });
        window.open("mailto:revrec-support@chargebee.com");
    };

    handleRevRecSwitch = (rrOrgId, rrEnabled, selectedBusinessEntity, orgConfigs, currentOrganization) => {
        let newUrl;
        let revrecId = currentOrganization.id;
        newUrl = `/${revrecId}`;
        if (rrEnabled) {
            // Switching to the RR standard site.

            if (rrOrgId && rrOrgId != "") {
                revrecId = rrOrgId;
            }

            if (selectedBusinessEntity) {
                // Switch to the corresponding RR standard BE site.
                const cfg =
                    orgConfigs &&
                    orgConfigs.find(
                        (oc) =>
                            oc.id ==
                            "revrec/orgId/" +
                            selectedBusinessEntity.Business_Entity_Id
                    );
                revrecId = (cfg && cfg.value) || revrecId;
            }

            newUrl = `/${revrecId}`;
        }

        return newUrl
    }

    handleAcUpdate = (acOrgId, currentOrganization) => {
        let newUrl;
        let acId = currentOrganization.id;

        if (acOrgId && acOrgId != "") {
            acId = acOrgId;
        }

        newUrl = `/ac/${acId}`;
        return newUrl;
    }

    endImpersonation = async () => {

        const user = await Auth.currentAuthenticatedUser();

        if (user) {
            try {
                await removeImpersonation();
                await swal({
                    title: "Ended Impersonation",
                    text: "Refresh and login again",
                    timeout: 3000,
                    icon: "success"
                });

                this.signOut(false);
            } catch (e) {
                console.error(e, e.stack);
                await swal({
                    text: `Could not end impersonation. Try to logout. ${e.toString()}`,
                    timeout: 3000,
                    icon: "error"
                });
            }
        }
    };

    setProductDetails = (isACSite) => {
        setData2("productSpace", `${isACSite ? 'ac' : 'revrec'}`);
        currentProduct.displayName = `${isACSite ? 'RevRec Premium' : 'RevRec'}`;
        currentProduct.name = `${isACSite ? 'ac' : 'revrec'}`;
    }

    render() {
        const {
            classes,
            currentUser,
            currentOrganization,
            clientTables,
            id,
            orgConfig,
            history,
            organizations,
            isACSite,
            rrEnabled,
            productSpace,
            siteType,
            acEnabled,
            acOrgId,
            acTimeZone,
            rrOrgId,
            isDemoSite,
            cookies
        } = this.props;
        const { activeNavItemID, collapsed, selectedBusinessEntity } = this.state;
        const menuProps = {
            clientTables,
            currentUser,
            orgConfig,
            space: productSpace == "ac" ||
                window.location.pathname.includes("/ac/")
                ? "ac"
                : "revrec"
        };

        const currentServiceProfile =
            window.location.hostname === "localhost"
                ? cookies.get("simulatedLocalRedirectProfile") ||
                config?.serviceProfile
                : config?.serviceProfile;

        const businessEntities = currentOrganization.businessEntities || [];
        let entitySwitcher = [];
        let switchers = [siteSwitcher]

        if ((menuProps.space == 'ac' || isACSite || !rrEnabled) && businessEntities.length > 0) {
            entitySwitcher = {
                id: "brand-switcher",
                icon: "building",
                description: `${(selectedBusinessEntity && selectedBusinessEntity.Timezone) || acTimeZone}`,
                activeItem: {
                    id: "selected-entity",
                    label: `${(selectedBusinessEntity && selectedBusinessEntity.Name) || "Unknown"}`,
                    description: `${(selectedBusinessEntity && selectedBusinessEntity.Timezone) || acTimeZone}`,
                    icon: "building",
                    badge: {
                        label: "Entity",
                        variant: 'sucess'
                    }
                },
                onClickClosePopover: true,
                variant: "outline",
                items: businessEntities.map((be) => ({
                    id: be.Business_Entity_Id,
                    label: be.Name,
                    icon: 'building',
                    onClick: (e) => {
                        const entityId = be.Business_Entity_Id;
                        this.props.currentOrganization.be_id = entityId;
                        UserActions.setCurrentOrganization(this.props.currentOrganization, false);

                        for (const be of this.props.currentOrganization.businessEntities) {
                            if (be.Business_Entity_Id == entityId) {
                                this.setState({
                                    selectedBusinessEntity: be
                                });
                                setCookies("businessEntityId", be.Business_Entity_Id, {
                                    path: "/"
                                });
                                break;
                            }
                        }
                    }
                })),
                itemListLabelText: "Entities",
                activeItemLabelText: "Currently viewing",
                width: "small",
                searchPlaceholderText: "Search entities",
                onSearch: async (query) => {
                    // Return filtered items or undefined to show all
                    if (!query) return;
                    // Can return filtered items from API
                    return entitySwitcher.items.filter((entity) =>
                        entity.label.toLowerCase().includes(query.toLowerCase())
                    );
                },
                noItemsFoundText: "No entity found",
                itemListLabelText: "Other entities you have access to",
            };
            switchers = [siteSwitcher, entitySwitcher]
        }


        siteSwitcher.items = []
        if (siteSwitcher.actions.length == 0) {
            siteSwitcher.actions.push(
                {
                    id: "settings",
                    icon: "settings",
                    onClick: (e) => {
                        const linkTo = menuProps.space == 'ac' || window.location.pathname.includes('/ac/')
                            ? `/ac/${currentOrganization.id}/accounting-settings` :
                            `${currentOrganization.id}/organization/settings?tab=1`
                        history.push(linkTo)
                    },
                    tooltip: "Settings"
                }, {
                id: "Clear Data",
                icon: "trash",
                onClick: (e) => this.onDelete(e),
                tooltip: "Clear Data"
            })

            if (currentOrganization.id.startsWith('9')) {
                siteSwitcher.actions.unshift({
                    id: "Load Sample Data",
                    icon: "copy",
                    onClick: (e) => this.onCopy(e),
                    tooltip: "Load Sample Data"
                })
            }
        }

        if ((menuProps.space == 'ac') || window.location.pathname.includes('/ac/')) {
            currentProduct.displayName = "RevRec Premium";
            currentProduct.name = "ac";
        }
        const user = {
            name: `${currentUser.attributes.name || currentUser.attributes.email}`,
            avatarURL: "",
            email: `${currentUser.attributes && currentUser.attributes.email}`,
            description: `${currentUser.attributes && currentUser.attributes.email}`,
            subItems: [
                {
                    id: "profile",
                    label: "Profile",
                    leadingIcon: "user",
                    onClick: () => {
                        if (currentUser.isChargebeeUser &&
                            currentOrganization.chargebeeEditProfileUrl) {
                            window.location.href = `${currentOrganization.chargebeeEditProfileUrl}`;
                        }
                    }
                },
                {
                    id: "Current Profile",
                    label: "Service Profile: " + currentServiceProfile,
                    leadingIcon: "info"
                },
                {
                    id: "logout",
                    label: "Logout",
                    onClick: () => this.signOut(true)
                },
            ],
        };
        if (currentUser && !currentUser.isChargebeeUser) {
            user.subItems[0].linkTo = ((menuProps.space == 'ac') || window.location.pathname.includes('/ac/')) ?
                            `ac/${currentOrganization.id}/profile` : "profile"
        }
        if (currentUser && currentUser.impersonation) {
            user.subItems.unshift({
                id: "impersonation",
                label: "End Impersonation",
                onClick: () => this.endImpersonation()
            })
        }
        const needHelp = {
            label: "Need Help?",
            id: "need-help",
            subItems: [
                {
                    id: "Chargebee Copilot",
                    label: "Chargebee Copilot",
                    leadingImageURL: "https://cdn.ai.chargebee.com/copilot-ui/ai-icon.svg",
                    onClick: () => window.ChargebeeCopilot?.open(),
                },
                {
                    id: "docs",
                    label: "Help Documentation",
                    leadingIcon: "file-question-mark",
                    onClick: () => {
                        const url = menuProps.space == 'ac' ? 'https://www.chargebee.com/docs/revrec/revrec-premium/revrec-premium-quick-start-guide' : 'https://www.chargebee.com/docs/revrec/getting-started-with-revrec/quick-start'
                        window.open(url, "_blank")
                    }
                },
                {
                    id: "support",
                    leadingIcon: "send",
                    label: "Contact Support",
                    linkTo: "/help/contact",
                    onClick: () => this.contactSupport()
                },
            ],
            linkTo: "/help",
            show: true,
        };

        let switchToOptions = [{
            name: "billing",
            displayName: "Billing",
            description: "Subscription billing and revenue management platform",
            linkTo: "billing",
            onClick: () => {
                window.location.href = "https://app.chargebee.com/login";
            }
        }]

        // Populate Switch to options
        if ((menuProps.space == 'ac' && rrEnabled && isDemoSite == false) || window.location.pathname.includes('/ac/')) {

            switchToOptions.push({
                name: "RevRec",
                displayName: "RevRec",
                description: "RevRec Recognition for standard revenue accounting needs",
                linkTo: "dashboards",
                onClick: () => {
                    const { currentOrganization } = this.props
                    const rrurl = this.handleRevRecSwitch(rrOrgId, rrEnabled, selectedBusinessEntity, orgConfig, currentOrganization)
                    setData2("productSpace", "revrec");
                    currentProduct.displayName = "RevRec";
                    currentProduct.name = "revrec";
                    window.location = `${rrurl}`
                }
            })
        } else if (acEnabled) {
            switchToOptions.push({
                name: "accounting central",
                displayName: "RevRec Premium",
                description: "RevRec Premium for advanced revenue accounting needs",
                onClick: () => {
                    setData2("productSpace", "ac");
                    const acUrl = this.handleAcUpdate(acOrgId, currentOrganization)
                    currentProduct.displayName = "RevRec Premium";
                    currentProduct.name = "ac";
                    window.location = `${acUrl}`
                }
            })
        }
        // Populate sites
        organizations && organizations.map((org) => {
            siteSwitcher.items.push({
                id: `${org.id}`,
                label: `${org.name}`,
                description: `${org.domain ? org.domain + ' |' : ''}  ${org.id}`,
                badge: {
                    label: `${org.id.startsWith('9') ? "Test" : "Live"}`,
                    variant: `${org.id.startsWith('9') ? "warning" : "success"}`
                },
                actions: [
                    {
                        id: "view-site",
                        label: "View Site",
                        onClick: async () => {
                            const orgConfig = await getSiteConfig(org.id);
                            const siteConfig = orgConfig.find(
                                (cfg) => cfg.id === "site/type"
                            );
                            const isACSite = (siteConfig && siteConfig.value == "ac") || false;
                            this.setProductDetails(isACSite);
                            if (isACSite) {
                                history.push(`/ac/${org.id}`)
                            } else {
                                history.push(`/${org.id}/`)
                            }

                            if (org.id.startsWith('1') && siteSwitcher.actions.length > 2) {
                                siteSwitcher.actions.shift()
                            }

                            if (org.id.startsWith('9') && siteSwitcher.actions.length < 3) {
                                siteSwitcher.actions.unshift({
                                    id: "Load Sample Data",
                                    icon: "copy",
                                    onClick: (e) => this.onCopy(e),
                                    tooltip: "Load Sample Data"
                                })
                            }

                        }
                    },
                ],
            });
        });

        if (currentOrganization) {
            siteSwitcher.activeItem = {
                id: `${currentOrganization.id}`,
                label: `${currentOrganization.name}`,
                description: `${currentOrganization.id}`,
                badge: {
                    label: `${currentOrganization.id.startsWith('9') ? "Test" : "Live"}`,
                    variant: `${currentOrganization.id.startsWith('9') ? "warning" : "success"}`
                }
            };

        }

        //console.error("SPACE ===> ", this.props.space, menuProps.space);
        const revEssential =
            (currentOrganization &&
                currentOrganization.license &&
                currentOrganization.license.name === "rev-essential") ||
            false;
        const superAdminLevel = SecurityUtils.getSuperAdminLevel(currentUser);
        const disableActionsForQuickView =
            revEssential && superAdminLevel < SecurityUtils.SUPER_ADMIN_LEVEL_1;

        const navItems = getMenuItems(this.props, menuProps, disableActionsForQuickView);
        const footerNavItems = []
        // Add Get Started item for RevRec
        if ((!menuProps.space || menuProps.space === "revrec") &&
            !disableActionsForQuickView &&
            !currentOrganization.id.startsWith("6") &&
            !currentOrganization.id.startsWith("7")) {
            footerNavItems.push({
                id: "Get Started",
                label: "Get Started",
                leadingIcon: "flag",
                onClick: () => this.showGetStarted()
            })
        }

        //Add Get Started item for AC
        if ((!menuProps.space || menuProps.space === "ac") &&
            !disableActionsForQuickView &&
            !currentOrganization.id.startsWith("6") &&
            !currentOrganization.id.startsWith("7")) {
            footerNavItems.push({
                id: "Onboarding Tour",
                label: "Onboarding Tour",
                leadingIcon: "flag",
                onClick: () => this.showAcOnboardingTour()
            })
        }

        return (
            <div
                id={id}
                className={classes.contentWrapper}
            >
                <CBNavbar
                    collapsed={collapsed}
                    lang="en"
                    renderLink={this.customLinkRenderer}
                    hideCollapseTrigger={false}
                >
                    <CBNavbar.Header
                        switchers={switchers}
                        currentProduct={currentProduct}
                        switchToOptions={switchToOptions}
                        exploreProductOptions={exploreProductOptions}
                    />
                    <CBNavbar.Body
                        showSearch
                        // onSearchTrigger={handleSearch}
                        items={navItems}
                        activeNavItemID={activeNavItemID}
                        onItemClick={this.handleItemClick}
                        placeholderCount={6}
                    />
                    <div className={classes.content}>

                        <div className={classes.root}>

                            {!collapsed && disableActionsForQuickView && (
                                <Alert
                                    icon={false}
                                    severity="info"
                                    className={classes.alert}
                                >
                                    <h4 className={classes.alertHeading}>
                                        Unlock More RevRec Features
                                    </h4>
                                    <small>
                                        Tailor revenue recognition to your unique
                                        needs with <b>custom rules</b>, and access{" "}
                                        <b>advanced insights</b>.
                                    </small>
                                    <div className={classes.alertButton}>
                                        <Button
                                            color="primary"
                                            onClick={() => {
                                                this.callExpert();
                                            }}
                                            variant="contained"
                                        >
                                            <small>{"Talk to an Expert"}</small>
                                        </Button>
                                    </div>
                                </Alert>
                            )}
                            {!collapsed && (
                                <JobProgress
                                    currentUser={currentUser}
                                    currentOrganization={currentOrganization}
                                />
                            )}
                        </div>
                    </div>
                    <CBNavbar.Footer
                        items={footerNavItems}
                        user={user}
                        needHelp={needHelp}
                    // whatsNew={whatsNew}
                    />
                </CBNavbar>

            </div>
        );
    }
}

MenuSidenavCompact.propTypes = {
    classes: PropTypes.shape({}).isRequired
};

function mapStateToProps(state, props) {
    const orgConfigs = getOrgConfigurations(state) || props.orgConfig;

    const siteConfig =
        orgConfigs && orgConfigs.find((e) => e.id == "site/type");
    const isACSite = (siteConfig && siteConfig.value == "ac") || false;

    const acSegregateByBusinessEntityConfig =
        orgConfigs &&
        orgConfigs.find((oc) => oc.id == "ac/segregateByBusinessEntity");
    const siteTypeConfig =
        orgConfigs && orgConfigs.find((oc) => oc.id == "site/type");
    const acEnabledConfig =
        orgConfigs && orgConfigs.find((oc) => oc.id == "ac/enabled");
    const acOrgIdConfig =
        orgConfigs && orgConfigs.find((oc) => oc.id == "ac/orgId");
    const acTimeZoneConfig =
        orgConfigs && orgConfigs.find((oc) => oc.id === "ac/timezone");
    const demoSiteConfig =
        orgConfigs && orgConfigs.find((oc) => oc.id === "ac/demoSite");

    const isDemoSite = (demoSiteConfig && demoSiteConfig.value) || false;
    const siteType = siteTypeConfig && siteTypeConfig.value;
    const acEnabled = (acEnabledConfig && acEnabledConfig.value) || false;
    const acOrgId = acOrgIdConfig && acOrgIdConfig.value;
    const acTimeZone = acTimeZoneConfig && acTimeZoneConfig.value;
    const acSegregateByBusinessEntity =
        (acSegregateByBusinessEntityConfig &&
            acSegregateByBusinessEntityConfig.value) ||
        false;

    const rrEnabledConfig =
        orgConfigs && orgConfigs.find((oc) => oc.id == "revrec/enabled");
    const rrOrgIdConfig =
        orgConfigs && orgConfigs.find((oc) => oc.id == "revrec/orgId");
    const rrEnabled = rrEnabledConfig ? rrEnabledConfig.value : true;
    const rrOrgId = rrOrgIdConfig && rrOrgIdConfig.value;
    const toReturn = {
        orgConfig: orgConfigs,
        currentUser: currentUser(state),
        currentOrganization: currentOrganization(state),
        clientTables: getClientTablesConfig(state),
        productSpace: state.data.productSpace,
        triggerAcTour: triggerAcTour(state),
        isACSite,
        acSegregateByBusinessEntity,
        rrEnabled,
        isDemoSite,
        siteType,
        acEnabled,
        acOrgId,
        acTimeZone,
        rrOrgId
    };
    return toReturn;
}

export default compose(
    withRouter,
    withCookies,
    withStyles(styles),
    connect(mapStateToProps, {})
)(MenuSidenavCompact);
